var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUploadOk = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#5CBA38"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 10.5C12.9624 10.5 10.5 12.9624 10.5 16C10.5 19.0376 12.9624 21.5 16 21.5C19.0376 21.5 21.5 19.0376 21.5 16C21.5 12.9624 19.0376 10.5 16 10.5ZM9 16C9 12.134 12.134 9 16 9C19.866 9 23 12.134 23 16C23 19.866 19.866 23 16 23C12.134 23 9 19.866 9 16ZM19.0303 14.2197C19.3232 14.5126 19.3232 14.9874 19.0303 15.2803L15.5303 18.7803C15.2374 19.0732 14.7626 19.0732 14.4697 18.7803L12.9697 17.2803C12.6768 16.9874 12.6768 16.5126 12.9697 16.2197C13.2626 15.9268 13.7374 15.9268 14.0303 16.2197L15 17.1893L17.9697 14.2197C18.2626 13.9268 18.7374 13.9268 19.0303 14.2197Z",
  fill: "white"
})));
export { SvgUploadOk as ReactComponent };